<div
  class="chart-container"
  [class]="
    'chart-' +
    (height === '200px'
      ? 'small'
      : height === '400px'
        ? 'large'
        : height === '500px'
          ? 'xlarge'
          : 'medium')
  "
  [style.height]="height"
>
  <canvas *ngIf="chartData && chartData.datasets && chartData.datasets.length > 0"></canvas>
  <div
    class="chart-loading"
    *ngIf="!chartData || !chartData.datasets || chartData.datasets.length === 0"
  >
    <div>
      <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem; margin-right: 0.5rem"></i>
      Loading chart...
    </div>
  </div>
  <div class="chart-error" *ngIf="chartData && chartData.error">
    <div>
      <i class="pi pi-exclamation-triangle" style="font-size: 1.5rem; margin-right: 0.5rem"></i>
      {{ chartData.error }}
    </div>
  </div>
</div>
